import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";

// Generic "list of short text entries" editor used for skills, projects,
// education, employment, volunteer work and referees — all of which the
// backend stores as simple string arrays on the Bio record.
export default function EditableListSection({ items, onChange, editing, placeholder, pillStyle = false }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    if (!draft.trim()) return;
    onChange([...(items || []), draft.trim()]);
    setDraft("");
  };

  const remove = (index) => {
    const next = [...items];
    next.splice(index, 1);
    onChange(next);
  };

  const list = items || [];

  if (!editing && list.length === 0) {
    return <p className="text-sm text-slate-400">Nothing added yet.</p>;
  }

  return (
    <div>
      {pillStyle ? (
        <div className="flex flex-wrap gap-2">
          {list.map((item, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-sm font-medium text-primary-700"
            >
              {item}
              {editing && (
                <button onClick={() => remove(i)} aria-label={`Remove ${item}`} className="text-primary-400 hover:text-primary-700">
                  <FiX className="h-3.5 w-3.5" />
                </button>
              )}
            </span>
          ))}
        </div>
      ) : (
        <ul className="space-y-2">
          {list.map((item, i) => (
            <li
              key={i}
              className="flex items-start justify-between gap-3 rounded-lg border border-slate-100 bg-slate-50/60 px-3 py-2 text-sm text-slate-700"
            >
              <span>{item}</span>
              {editing && (
                <button onClick={() => remove(i)} aria-label="Remove entry" className="shrink-0 text-slate-400 hover:text-red-500">
                  <FiX className="h-4 w-4" />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}

      {editing && (
        <div className="mt-3 flex gap-2">
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
            placeholder={placeholder}
            className="h-9 flex-1 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-100"
          />
          <button
            onClick={add}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 hover:bg-primary-100"
            aria-label="Add"
          >
            <FiPlus className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  );
}
